const coversList = {
	
	ui: {},

	init: function() {
		const coversList = document.querySelectorAll('.js-coversList');

		coversList.forEach(coverList => {
			let reverseDirection = false;
			if (coverList.classList.contains('--reverse')) {
				reverseDirection = true;
			}
			const swiperCoverList = new Swiper(coverList, {
				slidesPerView: "auto",
				spaceBetween: 24,
				loop: true,
				speed: 2500,
				allowTouchMove: false,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
					reverseDirection: reverseDirection
				},
				containerModifierClass: 'coversListLine',
				wrapperClass: 'coversListLine__content',
				slideClass: 'coversListLine__content__cover',
				slideActiveClass: 'active'
			});
		});
	},
};

module.exports = coversList;